export class GridColumnTarget {
    #grid;
    /** Field writes dropped because the grid no longer held the row. */
    droppedWrites = 0;
    constructor(grid) {
        this.#grid = grid;
    }
    begin() {
        // Writes apply immediately; the grid's next frame is the batch boundary.
    }
    value(rowId, column, value) {
        if (!this.#grid.applyRowField(rowId, column, value)) {
            this.droppedWrites += 1;
        }
    }
    unavailable(rowId, column) {
        this.value(rowId, column, undefined);
    }
    end() {
        // Nothing buffered.
    }
}
//# sourceMappingURL=keyedColumnTarget.js.map